export default {
    path: '/',
    component: () => import('@/views/layouts/DefaultLayout.vue'),
    children: [
        {
            path: '',
            name: 'LandingPage',
            component: () => import('@/views/LandingPage.vue'),
        },
        {
            path: 'login',
            name: 'Login',
            component: () => import('@/views/LoginView.vue'),
        },
        {
            path: 'direct-login',
            name: 'DirectLogin',
            component: () => import('@/views/DirectLogin.vue'),
        },
        {
            path: 'services',
            name: 'Services',
            component: () => import('@/components/LandingServices.vue'),
        },
        {
            path: 'price',
            name: 'PricePlans',
            component: () => import('@/components/PricePlans.vue'),
        },
        {
            path: 'contact',
            name: 'Contact',
            component: () => import('@/components/ContactUs.vue'),
        },
        {
            path: 'terms',
            name: 'Policies',
            component: () => import('@/components/TermsPolicy.vue'),
        },
        {
            path: 'subscription',
            name: 'Subscription',
            component: () => import('@/views/SubscriptionView.vue'),
        },
        {
            path: 'help',
            name: 'Help',
            component: () => import('@/views/ComingSoon.vue'),
        },
        {
            path: 'instructions',
            name: 'Instructions',
            component: () => import('@/views/ComingSoon.vue'),
        },
    ]
}
